// extracted by css-extract-rspack-plugin
export default {"cls1":"Search-cls1_N94","cls2":"Search-cls2_QQp Search-cls1_N94"};